import * as React from 'react'
import styled, { ThemeProps } from 'style/styled-components'
import Theme from 'style/theme'

const StyledSelect = styled.select`
  border: 1px solid ${(props: ThemeProps<Theme>): string => props.theme.select.borderColor};
  padding: 6px 12px;
`

const Select = (props: React.HTMLAttributes<HTMLSelectElement>): JSX.Element => (
  <StyledSelect {...props} />
)

export default Select



// WEBPACK FOOTER //
// ./src/components/_atoms/select.tsx